var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mgl-geojson-layer',{ref:_vm.reference,attrs:{"source-id":_vm.sourceId,"source":_vm.source,"layer-id":_vm.layerId,"layer":_vm.layer},on:{"click":_vm.clickFunction}})}
var staticRenderFns = []

export { render, staticRenderFns }